module.exports = __webpack_public_path__ + "static/media/dropdown_icon.0d8cd885.svg";